import React, { useRef, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import Loader from '../components/Loader.js'
import { useSelector, useDispatch } from 'react-redux'
import 'swiper/css/pagination'
// import { Pagination } from "swiper";
import { getAllCategories } from '../actions/categoryAction'
import { clearErrors, getProduct } from '../actions/productAction'
// Import Swiper styles
// import "swiper/css";
import 'swiper/css/effect-fade'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
// import required modules
import {
  EffectFade,
  Autoplay,
  Navigation,
  Pagination,
  FreeMode,
  Thumbs,
} from 'swiper'

const About = () => {
  const dispatch = useDispatch()
  const { categories } = useSelector((state) => state.categories)
  const { loading, error, products } = useSelector((state) => state.products)

  useEffect(() => {
    dispatch(getProduct())
    dispatch(getAllCategories())
  }, [dispatch, error, alert])

  return (
    <>
      {/* {loading ? (
        <Loader />
      ) : (
        <> */}
      {/*<!-- Page Banner Section Start -->*/}
      <div
        className='section page-banner-section'
        style={{ backgroundImage: 'url(../assets/images/banner.jpg)' }}
      >
        <div className='overlayBanner'></div>
        <div className='container'>
          {/*<!-- Page Banner Content End -->*/}
          <div className='page-banner-content'>
            <h2 className='title'>About Us</h2>

            <ul className='breadcrumb'>
              <li>
                <Link to='/'>Home</Link>
              </li>
              <li className='active'>About Us</li>
            </ul>
          </div>
          {/*<!-- Page Banner Content End -->*/}
        </div>
      </div>
      {/*<!-- Page Banner Section End -->*/}

      {/*<!-- History Section Start -->*/}
      <div className='section section-padding-02 pb-lg-5'>
        <div className='container'>
          {/*<!-- History content End -->*/}
          <div className='history-content '>
            <div className='section-title-03 text-center'>
              {/*<h6 className="sub-title">Our History</h6>*/}
              <h2 className='title'>
                KBM Training & Recruitment eCampus
              </h2>
              <h3 className="sub-title py-2">Your Gateway to AAT, ACCA, ACDAP, and CPD Qualifications</h3>
            </div>

            <p>Welcome to KBM Training & Recruitment eCampus, your trusted online learning platform for accounting, finance, and digital accounting qualifications. We offer globally recognised courses, including AAT, ACCA, and ACDAP qualifications, along with Continuing Professional Development (CPD) programmes to help professionals enhance their careers.</p>
            <p>At KBM eCampus, we provide flexible, high-quality training with expert tutors, hands-on practical experience, and career support. Whether you are starting your accounting journey or advancing your skills, our courses will help you succeed. We also guide students through ACCA registration, MyACCA account setup, and ACCA exemptions to ensure a smooth learning experience.</p>

            <p><strong>AAT Qualification
              – A Practical Pathway to Accounting</strong></p
            ><p>The AAT qualification is an excellent choice for those
              looking to enter or progress in the accounting profession. It is highly valued by employers and offers a
              clear progression route from foundation to professional levels.</p><p>We provide AAT courses under the new
              Q2022 syllabus, ensuring learners gain up-to-date accounting and finance skills.</p><p><strong>AAT Level 2
              Certificate in Accounting</strong></p><p>This entry-level course introduces fundamental accounting skills,
              including bookkeeping transactions, costing principles, and using digital accounting software. It is
              perfect for beginners looking to build a strong foundation.</p><p><strong>AAT Level 2 Certificate in
              Bookkeeping</strong></p><p>A focused qualification in bookkeeping, financial transactions, and ledger
              management, ideal for those pursuing bookkeeping roles or progressing to AAT Level 3. It builds a strong
              foundation for career growth in accounting.</p><p><strong>AAT Level 3 Certificate in Bookkeeping</strong>
            </p><p>A higher qualification in financial accounts, advanced bookkeeping, and VAT procedures, suited for
              those with aspirations for senior bookkeeper positions or moving up to AAT Level 4. It strengthens
              financial record-keeping and compliance knowledge, which is crucial for career development in
              accounting.</p><p><strong>AAT Level 3 Diploma in Accounting</strong></p><p>At this stage, learners develop
              advanced financial skills such as preparing financial statements, tax processes, and managing financial
              records. The AAT Level 3 qualification prepares students for mid-level accounting roles and progression to
              higher-level studies.</p><p><strong>AAT Level 4 Diploma in Professional Accounting</strong></p><p>The
              final level, AAT Level 4, covers complex accounting areas, including financial management, internal
              controls, and tax compliance. Completing this qualification allows students to progress to the ACCA course
              and claim ACCA exemptions.</p><p>An AAT qualification opens doors to careers such as bookkeeper, payroll
              administrator, accounts assistant, and more. Many learners use AAT's qualifications as a pathway to
              further professional studies like ACCA or ACDAP.</p><p><strong>ACCA Qualification – The Global Standard
              for Accountants</strong></p><p>The ACCA qualification is one of the most respected credentials in the
              accounting profession. It provides in-depth knowledge of financial management, auditing, and taxation.</p>
            <p>We offer a complete ACCA course covering all fundamental and professional-level modules. Our expert team
              assists students with the following:</p>
            <ul>
              <li>ACCA registration and creating a MyACCA account</li>
              <li>Understanding ACCA exemptions for AAT and degree holders</li>
              <li>Preparing for ACCA exams with high-quality learning resources</li>
            </ul>
            <p>With an ACCA qualification, students can go on to assume senior positions like financial accountant,
              management accountant, auditor, and tax professional.</p><p><strong>ACDAP – Leading the Future of Digital
              Accounting</strong></p><p>At KBM eCampus, we recognise the growing importance of digital accounting. Our
              ACDAP (Association of Certified Digital Accounting Professionals) qualifications focus on modern
              accounting technology, automation, and cloud-based finance tools. ACDAP course levels are as follows:</p>
            <ol>
              <li>Foundation Stage – Covers digital bookkeeping, payroll management, and financial
                software.
              </li>
              <li>Advanced Stage – Includes financial reporting, taxation, and digital auditing.</li>
              <li>Professional Stage – Focuses on strategic management accounting, corporate governance,
                and risk management.
              </li>
            </ol>
            <p>With an ACDAP qualification, learners become experts in cloud-based accounting software like Sage, Xero,
              QuickBooks, and IRIS, making them highly competitive in today's job market.</p><p><strong>CPD Courses –
              Stay Ahead in the Accounting Industry</strong></p><p>For career professionals who want to upgrade their
              skills and career opportunities, we provide Continuing Professional Development (CPD) courses. These
              advanced courses include the newest accounting trends, financial regulations, and digital finance
              developments.</p><p>Popular CPD courses include:</p>
            <ul>
              <li>Taxation and Compliance Changes</li>
              <li>Advanced Excel for Accountants</li>
              <li>Financial Reporting Updates</li>
              <li>Digital Accounting Trends</li>
            </ul>
            <p>CPD training assists professionals in keeping their skills current, enhancing their competencies, and
              opening up career prospects.</p><p><strong>Practical Training with Industry-Recognised Software</strong>
            </p><p>At KBM eCampus, we believe in learning through real-world experience. Our students gain hands-on
              training using actual business files and industry-standard accounting software, including Sage, Xero,
              QuickBooks, and IRIS.</p><p>As an ACCA Gold-Level Approved Firm, we provide practical experience that
              meets the Practical Experience Requirement (PER) for ACCA, AAT, and ACDAP qualifications.</p><p><strong>Career
              Support and Job Placement</strong></p><p>Beyond education, KBM eCampus helps learners secure accounting
              and finance jobs. Our career support services include:</p>
            <ul>
              <li>CV writing and interview preparation</li>
              <li>Job placements through leading recruitment platforms like Reed, Indeed, and Gumtree
              </li>
              <li>Networking with top employers in the finance and accounting industry</li>
            </ul>
            <p>Many of our learners secure employment even before completing their courses, thanks to our strong
              industry connections.</p><p><strong>Why Choose KBM eCampus?</strong></p>
            <ul>
              <li>AAT, ACCA, and ACDAP qualifications designed for career success</li>
              <li>Flexible learning options with live and recorded sessions</li>
              <li>Expert guidance on ACCA registration, MyACCA, and ACCA exemptions</li>
              <li>CPD courses to keep professionals updated with industry trends</li>
              <li>Hands-on practical training with actual business files and accounting software</li>
              <li>Dedicated career support and job placement assistance</li>
            </ul>
            <p><strong>Start Your Accounting Career with KBM eCampus Today</strong></p><p>If you are looking for a
              trusted online platform to study AAT, ACCA, ACDAP, and CPD courses, KBM eCampus is the right choice for
              you.</p><p>Join us today and take the next step toward a successful career in accounting and finance.</p>

          </div>
          {/*<!-- History content End -->*/}

          {/*<!-- History Icon End -->*/}
          {/*<div className='history-icon text-center'>
            <img src='../assets/images/icon/icon-5.jpg' alt='Icon' />
          </div>*/}
          {/*<!-- History Icon End -->*/}
        </div>
      </div>
      {/* <!-- History Section End -->*/}

      
      {/* </>
      )} */}
    </>
  )
}

export default About
